import React from "react";
import patientIcon from "../../assets/images/Patient.svg";
import userIcon from "../../assets/images/user_color.svg";
import service from "../../assets/images/service.svg";
import { Popover } from "antd";
import * as moment from "moment";

const PatientCard = (props) => {
  const {
    item,
    propsData,
    draggableStatus,
    popupContent,
    clicked,
    handleClickChange,
    changePatientStatustoCheckin,
    changePatientStatustoCheckout,
  } = props;
  // const { viewtype, queueitem } = propsData;
  // let { checkin_eligibility, checkout_eligibility, skip_eligibility } =
  //   queueitem;

  const renderTime = (date) => {
    return moment(date).format("hh:mm A");
  };
  // const cIncOut = () => (
  //   <>
  //     {viewtype == "doctor" ? (
  //       item.status === "3" ? (
  //         <button className="text-checkin-disable" disabled="true">
  //           C-IN
  //         </button>
  //       ) : (
  //         item.status === "4" && (
  //           <button className="text-checkin-disable" disabled="true">
  //             C-OUT
  //           </button>
  //         )
  //       )
  //     ) : item.status === "3" ? (
  //       viewtype == "technician" && checkin_eligibility == "technician" ? (
  //         <button
  //           className={
  //             item.bill_cancel_status == "YES"
  //               ? "text-cancelled-disable"
  //               : "text-checkin"
  //           }
  //           onClick={changePatientStatustoCheckin(propsData, "checkin")}
  //           disabled={item.bill_cancel_status == "YES" && true}
  //         >
  //           {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-IN"}
  //         </button>
  //       ) : viewtype != "technician" &&
  //         (checkin_eligibility == null ||
  //           checkin_eligibility == "secretary") ? (
  //         <button
  //           className={
  //             item.bill_cancel_status == "YES"
  //               ? "text-cancelled-disable"
  //               : "text-checkin"
  //           }
  //           onClick={changePatientStatustoCheckin(propsData, "checkin")}
  //           disabled={item.bill_cancel_status == "YES" && true}
  //         >
  //           {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-IN"}
  //         </button>
  //       ) : (
  //         <button
  //           className={
  //             item.bill_cancel_status == "YES"
  //               ? "text-cancelled-disable"
  //               : "text-checkin-disable"
  //           }
  //           disabled="true"
  //         >
  //           {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-IN"}
  //         </button>
  //       )
  //     ) : (
  //       item.status === "4" &&
  //       (viewtype == "technician" && checkout_eligibility == "technician" ? (
  //         <button
  //           className={
  //             item.bill_cancel_status == "YES"
  //               ? "text-cancelled-disable"
  //               : "text-checkout"
  //           }
  //           onClick={changePatientStatustoCheckout(propsData, "checkout")}
  //           disabled={item.bill_cancel_status == "YES" && true}
  //         >
  //           {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-OUT"}
  //         </button>
  //       ) : viewtype != "technician" &&
  //         (checkout_eligibility == null ||
  //           checkout_eligibility == "secretary") ? (
  //         <button
  //           className={
  //             item.bill_cancel_status == "YES"
  //               ? "text-cancelled-disable"
  //               : "text-checkout"
  //           }
  //           onClick={changePatientStatustoCheckout(propsData, "checkout")}
  //           disabled={item.bill_cancel_status == "YES" && true}
  //         >
  //           {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-OUT"}
  //         </button>
  //       ) : (
  //         <button
  //           className={
  //             item.bill_cancel_status == "YES"
  //               ? "text-cancelled-disable"
  //               : "text-checkin-disable"
  //           }
  //           disabled="true"
  //         >
  //           {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-OUT"}
  //         </button>
  //       ))
  //     )}
  //   </>
  // );
  return (
    <>
      {console.log("PatientCard", item)}
      <div class="PatientCard">
        <div class="row pl-3 pt-1 mb-0 pb-0">
          <div class="col-8">
            <div class="row">
              <img
                alt=""
                src={patientIcon}
                width={35}
                height={20}
                class="patientIcon"
              />
              <span class="Patientname">
                {item.name ? item.name : "Patient 12"}
              </span>
            </div>
            <div class="row pl-2 mt-1">
              <img
                alt=""
                src={userIcon}
                width={20}
                height={20}
                className="uidIcon"
              />
              <span class="PatientUid">{item.umr ? item.umr : "--"}</span>
            </div>
            <div class="row pl-2 mt-1">
              <img
                alt=""
                src={userIcon}
                width={20}
                height={20}
                className="uidIcon"
              />
              <span class="PatientUid">Radiotherapy</span>
            </div>
            <div class="row pl-2 mt-1">
              <img
                alt=""
                src={service}
                width={20}
                height={20}
                className="uidIcon"
              />
              <span className="Patientname">
                OP
                <span className="Patientname ml-4">
                  Apt: {renderTime(item.appointment_date)}
                </span>
              </span>
            </div>
          </div>
          <div class="col-4">
            <span class="ml-4 time">{item.waitingTAT}</span>
            {/* <div className="statusDiv mt-1">
              <span class="status">C-IN</span>
            </div> */}
            {/* <div className="status">{cIncOut()}</div> */}
            <div className="status">C-In</div>
            <div className="col-4 ml-3">
              {/* {viewtype == "doctor" ? ( */}
              <p>
                <img
                  src="/assets/images/icons/more-icon.png"
                  alt="more"
                  srcSet=""
                  draggable={draggableStatus}
                  width="15px"
                />
              </p>
              {/* ) : (
                <p>
                  <Popover
                    content={popupContent}
                    trigger="click"
                    visible={clicked}
                    onVisibleChange={handleClickChange}
                  >
                    <img
                      src="/assets/images/icons/more-icon.png"
                      alt="more"
                      srcSet=""
                      draggable={draggableStatus}
                      width="15px"
                    />
                  </Popover>
                </p>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientCard;
